/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { useIntl } from 'react-intl'

import { EuiFieldSearch } from '@elastic/eui'

const SearchBar: React.FunctionComponent = () => {
  const { formatMessage } = useIntl()

  const placeholder = formatMessage({
    id: 'networkSecurity.list.search.placeholder',
    defaultMessage: 'Search',
  })

  const label = formatMessage({
    id: 'networkSecurity.list.search.label',
    defaultMessage: 'Search by name',
  })

  const [params, setParams] = useSearchParams()

  return (
    <EuiFieldSearch
      placeholder={placeholder}
      defaultValue={params.get('search') ?? ''}
      onSearch={(value) => {
        setParams(
          (params) => {
            const newParams = new URLSearchParams(params)
            newParams.set('search', value)
            return newParams
          },
          { replace: true },
        )
      }}
      isClearable={true}
      aria-label={label}
    />
  )
}

export default SearchBar
